import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IGanttPanelButtonProps } from './types';
import { BOARD_SECTION_GANTT_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function GanttPanelButton ({
    indicatorBoolean,
    isEssentialFeature,
    isDisabled,
    tooltip,
    onClick
}: IGanttPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.GANTT}
            indicatorBoolean={indicatorBoolean}
            isDisabled={isDisabled}
            isEssentialFeature={isEssentialFeature}
            title={BOARD_SECTION_GANTT_BUTTON}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.GANTT);
                onClick();
            }}
        />
    );
}
